import EventEmitter from 'eventemitter2';
import { flatten } from 'array-flatten';
import toposort from 'toposort';
import * as log from 'loglevel';

EventEmitter.defaultMaxListeners = 100;

class Bootstrap extends EventEmitter{
	constructor(...moduleClasses){
		super();
		this.modules = new Map();
		this.run 	 = this.run.bind(this);


		this._running = false;

		this._ready = false;

		if(document.body)
			this._ready = true;
		else{
		    document.addEventListener("DOMContentLoaded", () => {
				this._ready = true;
		       	if(this._runRequested)
		       		this.run();
		    });
		}

		this.add(...moduleClasses);
	}

	sort(){
		//Create dependencies
		this.modules.forEach(module => {
			module.dependencies.forEach(dependency => {
				if(!this.modules.has(dependency))
					this.modules.set(dependency, new dependency(this));
			});
		});

		this.modules = new Map(this.toposort(Array.from(this.modules.values())).map(module => [module.constructor, module]));
		this.modules.forEach(module => module.enabled = true);
	}

	/**
	 * Stable Topological sorting by module priority and dependencies
	 * @param {Array} moduleInstances - The modules to sort.
	 */
	toposort(modules){
		let D = new Map();
		modules.forEach(module => D.set(module, Array.from(module.dependencies.keys()).map(clazz => this.modules.get(clazz))));


		const G = Array.from(D.keys()).reduce((p, c) => p.set( c, Array.from(D.keys()).filter(e => D.get(e).includes(c))), new Map());
		const Q = Array.from(D.keys()).filter(e => D.get(e).length == 0).sort((a, b) => a.priority - b.priority);
		const S = [];
		while (Q.length) {
			const u = Q.pop();
			S.push(u);
			var temp = [];
			G.get(u).forEach(v => {
				D.set(v, D.get(v).filter(e => e !== u));
				if (D.get(v).length == 0) {
					temp.push(v);
				}
			});
			temp.sort((a, b) => a.priority - b.priority).forEach(item => Q.push(item));
		}
		return S;
	}

	/**
	 * Add Bootstrap modules
	 * @param {Array} moduleClasses - The modules to add.
	 */
	add(...moduleClasses){
		moduleClasses = flatten(moduleClasses);
		//Creates defined modules
		moduleClasses.forEach(moduleClass => this.modules.set(moduleClass, new moduleClass(this)));

		this.sort();
	}

	/**
	 * Overrides a module by another
	 * @return {Module} The module
	 */
	override(overridenModuleClass, moduleClass){
		if(this.modules.has(overridenModule)){
			this.modules.delete(overridenModule);
			let instance = new moduleClass(this);
			this.modules.set(overridenModule, instance);
			this.modules.set(moduleClass, instance);
			this.sort();
		}
	}

	/**
	 *
	 * @return {Module} The module
	 */
	get(moduleClass){
		return this.modules.get(moduleClass);
	}

	async run(){
		if(!this._running){
			if(!this._ready){
				this._runRequested = true;
				return;
			}
			log.debug('Bootstrap', 'run');
			this._running = true;
			for(let method of ['init', 'before', 'run', 'after']){
				for(let [clazz, module] of Array.from(this.modules)){
					log.debug('Bootstrap', 'module', module.constructor.name, method);
					if(module.runnable) await module[method]();
				}
			}
			this._running = false;
		}
	}
}

export { Bootstrap };
export default Bootstrap;